import { render, staticRenderFns } from "./addPage.vue?vue&type=template&id=2f9939d9"
import script from "./addPage.vue?vue&type=script&lang=js"
export * from "./addPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9939d9')) {
      api.createRecord('2f9939d9', component.options)
    } else {
      api.reload('2f9939d9', component.options)
    }
    module.hot.accept("./addPage.vue?vue&type=template&id=2f9939d9", function () {
      api.rerender('2f9939d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bearingQuotation/addPage.vue"
export default component.exports